/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TwoFactorSetupResult } from '../../models/two-factor-setup-result';

export interface SetupRequired$Params {
  authorization: string;
}

export function setupRequired(http: HttpClient, rootUrl: string, params: SetupRequired$Params, context?: HttpContext): Observable<StrictHttpResponse<TwoFactorSetupResult>> {
  const rb = new RequestBuilder(rootUrl, setupRequired.PATH, 'post');
  if (params) {
    rb.header('authorization', params.authorization, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TwoFactorSetupResult>;
    })
  );
}

setupRequired.PATH = '/auth/2fa/setup-required/setup';
